module.exports = __webpack_public_path__ + "media/images/volleyball-image-2ae32294705d1c7a98af80a2d4d26963.jpg";